module.exports = __webpack_public_path__ + "img/cbc-logo.49ad108f.png";